import { FilterToolbarItemId } from 'src/components/Filters';
import { FilterToolbar } from 'src/components/FilterToolbar';
import { useFiltersHelpers } from 'src/components/FilterToolbar/useFiltersHelpers';
import { useMarketplacePaymentLinesFilters } from 'src/components/MainFilterBar/useMarketplacePaymentLinesFilters';
import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { MarketplacePaymentLineQuery } from 'src/WebApiController';

export const MarketplacePaymentsDetailsFilter = () => {
  const { filters } = useMarketplacePaymentLinesFilters();
  const {
    initialQuery,
    tempQuery,
    resetTempQuery,
    setFilterQuery,
    filterQuery: marketplacePaymentLineQuery,
  } = useFilterQueryContext<MarketplacePaymentLineQuery>();

  const { appliedFilters } = useFiltersHelpers({
    filters,
    activeQuery: marketplacePaymentLineQuery,
    mandatoryFiltersToShow: [
      'hasUnlinkedChargesCredits',
      'externalSaleIdContains',
    ],
    initialQuery,
  });

  return (
    <FilterToolbar
      onResetAll={() => setFilterQuery(initialQuery)}
      filterAppliedCounts={appliedFilters.length}
      filterAppliedIds={appliedFilters}
      onSubmitFilter={() => setFilterQuery(tempQuery)}
      filters={filters}
      resetTempQuery={resetTempQuery}
      tempQuery={tempQuery}
      showCustomFilterButton={false}
      showAllButton={false}
      mandatoryFiltersToShow={[
        'hasUnlinkedChargesCredits',
        'externalSaleIdContains',
      ]}
    />
  );
};
